<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'devicesActivationCrud'"
            :crudName="$t('Devices Activation')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "devicesActivationTable",
      showMessageImport: false,
      devicesActivationCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "unit_id",
        "device_id",
        "vehicle_id",
        "status",
        "actions",
      ],
      devicesList: [],
      vehiclesList: [],
      tableData: [
        "id",
        "unit_id",
        "device_id",
        "vehicle_id",
        "status"
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "unit_id", "device_id", "vehicle_id", "status"],
        sortable: ["id", "unit_id", "device_id", "vehicle_id", "status"],
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down"
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          unit_id: this.$t('Unit'),
          device_id: this.$t('Device Serial Number'),
          vehicle_id: this.$t('Vehicle'),
          status: this.$t('Status'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {
          status: [
            {id: 1, text: this.$t('Active')},
            {id: 0, text: this.$t('Inactive')}
          ],
          unit_id: [],
        },
        templates: {
          unit_id: function (h, row, index) {
            return row.unit?.name ?? ''
          },
          device_id: function (h, row, index) {
            return row.device ? row.device.serial_number : ""
          },
          vehicle_id: function (h, row, index) {
            return row.vehicle ? row.vehicle.name : ""
          },
        },
        requestFunction: function (data) {
          let requestData = {};


          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["unit", "device", "vehicle"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "deviceactivations",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        unit_id: this.$t('Unit'),
        device_id: this.$t('Device Serial Number'),
        vehicle_id: this.$t('Vehicle'),
        status: this.$t('Status'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }
    }
  },
  methods: {
    query(query) {
      let columns = {
        id: "id",
        name: "name",
        unit_id: "unit_id",
        device_id: "device[serial_number]",
        vehicle_id: "vehicle[name]",
        status: "status"
      };

      let filters = "";
      $.each(query, function (index, value) {
        if (value) {
          filters += columns[index] + "=" + value + "&";
        }
      });
      return filters;
    }
  },
  mounted() {
    axios.get(this.$store.state.api + 'devices?paginated=false').then(res => {
      this.devicesList = res.data.data || res.data;
    });

    axios.get(this.$store.state.api + 'units').then(res => {
      const units = res.data.data || res.data;
      this.optionsOrigin.listColumns.unit_id = units.map(f => ({
        id: f.id,
        text: f.name
      }));
    });
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
    